import React, { useContext } from 'react'
import PageModal from "components/PageModal/PageModal";
import AppDataContext from 'context/AppDataContext';
import SparklneChart from "assets/images/graph/SparklneChart.svg";
import SparkLineChart from 'components/SparkLineChart/SparkLineChart';


export default function GridModal({ closeModal }: any) {
  const { user, setGridModalShow, setNavText, setToggleModal }: any =
    useContext(AppDataContext);

  const tasks = [
    {
      name: "Review FY23 year end audit",
      status: "Not started",
    },
    {
      name: "Complete board presentation",
      status: "In progress",
    },
    {
      name: "Prepare FY24 Strategy Deck",
      status: "Not started",
    },
    {
      name: "Workshop with South American Team",
    },
    {
      name: "Ways of working ",
      status: "Active",
    },
  ];

  const goToRiskHealth = ()=> {
    setGridModalShow(false);
    setNavText("risk-health");
    setToggleModal(false);

  }


  return (
    <PageModal>
      <div className="modal-container">
        <div className="d-flex align-items-center justify-content-end mb-5 pb-3">
          <button className="btn btn-flat btn-lg text-white">
            <i className="icon-plus text-2x"></i>
          </button>
          <button
            onClick={() => closeModal()}
            className="btn btn-outline-secondary btn-lg"
          >
            Done
          </button>
        </div>

        <div className="row align-items-center pb-5">
          <div className="col-4">
            <h1 className="fw-300 ">Welcome back, {user?.fullName}</h1>
            <h4 className="text-gray-400 fw-300 mv-0">
              Since you've left, I've identified a few areas that need your
              attention.
            </h4>
            <b className="fw-800 text-5c">
              How would you like to start your day?
            </b>
          </div>

          <div className="col-8 d-inline-flex justify-content-end">
            <button className="btn btn-flat text-white">
              This week
              <span className="icon-chevron-down ml-2"></span>
            </button>
            <span className="vr text-3x mh-3 d-block"></span>
            <div className=" ph-3">
              <h6 className="fw-300 text-gray-500">Risks</h6>
              <h2 className="fw-300">20</h2>
            </div>
            <div className=" ph-3">
              <h6 className="fw-300 text-gray-500">In progress</h6>
              <h2 className="fw-300">5</h2>
            </div>
            <div className=" ph-3">
              <h6 className="fw-300 text-gray-500">Completed</h6>
              <h2 className="fw-300">200</h2>
            </div>
          </div>
        </div>

        <div className="row g-5">
          <div className="col">
            <div className="gradCard">
              <header className="d-flex justify-content-between mb-3">
                <div className="d-inline-block">
                  <h4 className="fw-300">Manage new risks</h4>
                  <h5 className="fw-300 text-gray-500">
                    15 issues have been identified that need your attention.
                  </h5>
                </div>

                <button
                  onClick={() => goToRiskHealth()}
                  className="btn btn-outline-secondary btn-lg "
                >
                  Get started
                  <i className="ml-2 icon-arrow-right"></i>
                </button>
              </header>
              <SparkLineChart />
            </div>
          </div>

          <div className="col">
            <div className="gradCard">
              <header className="d-flex justify-content-between ">
                <div className="d-inline-block">
                  <h4 className="fw-300">Your Tasks</h4>
                  <h5 className="fw-300 text-gray-500">5 items are overdue</h5>
                </div>

                <button
                  onClick={() => goToRiskHealth()}
                  className="btn btn-outline-secondary btn-lg "
                >
                  Task Manager
                  <i className="ml-2 icon-arrow-right"></i>
                </button>
              </header>

              {tasks.map((task, i) => (
                <div
                  className="d-flex align-items-center justify-content-between border-bottom-gray-600 pv-4"
                  key={i}
                >
                  <div className="form-check">
                    <input className="form-check-input mr-3" type="checkbox" />
                    <label className="form-check-label">{task.name}</label>
                  </div>

                  {task.status && (
                    <div
                      className={`round ph-3 pv-1 ${
                        task.status === "In progress"
                          ? "bg-white text-blue-700"
                          : "bg-gray-800"
                      }`}
                    >
                      <span
                        className={`dot mr-2  ${
                          task.status === "In progress"
                            ? "bg-blue-700"
                            : "bg-gray-500"
                        }  `}
                      ></span>
                      {task.status}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="col">
            <div className="gradCard">
              <div className="ph-5 pt-3">
                <h3 className="fw-300">
                  Security comes first in U.S.-China economic relations, says
                  Treasury Secretary Yellen
                </h3>
                <p className="text-gray-400">
                  Supply chains will be disrupted based on ongoing geopolitical
                  crisis, Covid, and inflationary pressures.
                </p>
              </div>
            </div>

            <div className="row mt-5">
              <div className="col">
                <div className="gradCard">
                  <h4 className="fw-300">
                    'Leave pity city,' MillerKnoll CEO tells staff who asked
                    whether they'd lose bonuses
                  </h4>
                  <p className="text-gray-400">
                    Supply chains will be disrupted based on ongoing
                    geopolitical crisis, Covid, and inflationary pressures.
                  </p>
                </div>
              </div>

              <div className="col">
                <div className="gradCard">
                  <h4 className="fw-300">
                    McCarthy proposes changing access to food stamps as part of
                    debt limit debate
                  </h4>
                  <p className="text-gray-400 ">
                    Supply chains will be disrupted based on ongoing
                    geopolitical crisis, Covid, and inflationary pressures.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageModal>
  );
}
